__turbopack_context__.v({
  "children": "BottomSheet-module-scss-module__6S3r-a__children",
  "flatSheetOpen": "BottomSheet-module-scss-module__6S3r-a__flatSheetOpen",
  "flatSheetOpen_reserved": "BottomSheet-module-scss-module__6S3r-a__flatSheetOpen_reserved",
  "flatWrapper": "BottomSheet-module-scss-module__6S3r-a__flatWrapper",
  "openSheet": "BottomSheet-module-scss-module__6S3r-a__openSheet",
  "openSheetForm": "BottomSheet-module-scss-module__6S3r-a__openSheetForm",
  "reservedFlatSheet": "BottomSheet-module-scss-module__6S3r-a__reservedFlatSheet",
  "sheetForFlat": "BottomSheet-module-scss-module__6S3r-a__sheetForFlat",
  "sheetForFlat_reserved": "BottomSheet-module-scss-module__6S3r-a__sheetForFlat_reserved",
  "sheetForFloor": "BottomSheet-module-scss-module__6S3r-a__sheetForFloor",
  "sheetForRoot": "BottomSheet-module-scss-module__6S3r-a__sheetForRoot",
  "tagMob": "BottomSheet-module-scss-module__6S3r-a__tagMob",
  "toggler": "BottomSheet-module-scss-module__6S3r-a__toggler",
  "wrapper": "BottomSheet-module-scss-module__6S3r-a__wrapper",
});
